/**
 * Digital Advisor Solutions Service API 1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Observable } from 'rxjs';
import { AjaxRequest } from 'rxjs/observable/dom/AjaxObservable';
//@ts-ignore
// import * as models from '../model/models';
import { RemoteData } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { ObjectUtils } from '@assetmark/ui-kit/dist/utils/object.utils';


import { AddUpdateLead } from '../model/addUpdateLead';
import { AddUpdateLeadGoal } from '../model/addUpdateLeadGoal';
import { LastPageVisitedRequest } from '../model/lastPageVisitedRequest';
import { LeadAlertResponse } from '../model/leadAlertResponse';
import { LeadAlertsRequest } from '../model/leadAlertsRequest';
import { LeadGoal } from '../model/leadGoal';
import { LeadGoalResponse } from '../model/leadGoalResponse';
import { LeadProfileResponse } from '../model/leadProfileResponse';
import { LeadQuestionAnswers } from '../model/leadQuestionAnswers';
import { LeadRiskResponse } from '../model/leadRiskResponse';
import { LeadStatusFilterEnum } from '../model/leadStatusFilterEnum';
import { LeadStrategyInfoResponse } from '../model/leadStrategyInfoResponse';
import { LeadStrategyUpdateRequest } from '../model/leadStrategyUpdateRequest';
import { LeadUserResponse } from '../model/leadUserResponse';
import { OtherRetirementIncomeSourceType } from '../model/otherRetirementIncomeSourceType';
import { RiskQuestion } from '../model/riskQuestion';
import { StrategyAccountDetailsResponse } from '../model/strategyAccountDetailsResponse';

import {
	DasApiClient as ApiClient
	
} from '../../../apis/api.client';

// import isNotNullable = ObjectUtils.isNotNullable;

type TQueryParam = {
	key: string,
	value: string | string[] | boolean | number | Date | undefined,
}


// eslint-disable-next-line @typescript-eslint/no-namespace 
export namespace LeadService {
	/**
	* 
		* @summary Calling investor api for get lead alerts
	*/
	export function apiDasV1LeadAlertsGet(customHeaders: Object = {}): Observable<RemoteData<Array<LeadAlertResponse>>> {
		const path = `/api/das/v1/lead/alerts`.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadAlertsGet(): string {
		const path = '/api/das/v1/lead/alerts'.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investors service for update lead alerts
	* @param body - 
	*/
	export function apiDasV1LeadAlertsPut(body?: LeadAlertsRequest, customHeaders: Object = {}): Observable<RemoteData<boolean>> {
		const path = `/api/das/v1/lead/alerts`.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'put',
			body: body,
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadAlertsPut(body?: LeadAlertsRequest, ): string {
		const path = '/api/das/v1/lead/alerts'.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Get lead user
	* @param leadSearchText - 
	* @param advisorId - 
	* @param paginationFilterPageNumber - 
	* @param paginationFilterPageSize - 
	* @param clientStatusFilter - 
	*/
	export function apiDasV1LeadGet(leadSearchText?: string, advisorId?: Array<string>, paginationFilterPageNumber?: number, paginationFilterPageSize?: number, clientStatusFilter?: LeadStatusFilterEnum, customHeaders: Object = {}): Observable<RemoteData<LeadUserResponse>> {
		const path = `/api/das/v1/lead`.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
				{
					key: 'leadSearchText',
					value: leadSearchText
				},
				{
					key: 'advisorId',
					value: advisorId
				},
				{
					key: 'paginationFilter.PageNumber',
					value: paginationFilterPageNumber
				},
				{
					key: 'paginationFilter.PageSize',
					value: paginationFilterPageSize
				},
				{
					key: 'clientStatusFilter',
					value: clientStatusFilter
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadGet(leadSearchText?: string, advisorId?: Array<string>, paginationFilterPageNumber?: number, paginationFilterPageSize?: number, clientStatusFilter?: LeadStatusFilterEnum, ): string {
		const path = '/api/das/v1/lead'.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
			{
			key: 'leadSearchText',
			value: leadSearchText
			},
			{
			key: 'advisorId',
			value: advisorId
			},
			{
			key: 'paginationFilter.PageNumber',
			value: paginationFilterPageNumber
			},
			{
			key: 'paginationFilter.PageSize',
			value: paginationFilterPageSize
			},
			{
			key: 'clientStatusFilter',
			value: clientStatusFilter
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service and Get the Lead Goal by Goal Id.
	* @param goalId - Goal Id i.e 5b1d9c8a-eff2-41f1-ad2c-dc62e9460083
	* @param agentId - Agent Id i.e AG1634
	*/
	export function apiDasV1LeadGoalsGoalIdGet(goalId: string, agentId?: string, customHeaders: Object = {}): Observable<RemoteData<LeadGoalResponse>> {
		const path = `/api/das/v1/lead/goals/${encodeURIComponent(String(goalId))}`.replace(/^\//, '').replace('{' + 'goalId' + '}', String(goalId));
		const allQueryParams: TQueryParam[] = [
				{
					key: 'agentId',
					value: agentId
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadGoalsGoalIdGet(goalId: string, agentId?: string, ): string {
		const path = '/api/das/v1/lead/goals/${encodeURIComponent(String(goalId))}'.replace(/^\//, '').replace('{' + 'goalId' + '}', String(goalId));
		const allQueryParams: TQueryParam[] = [
			{
			key: 'agentId',
			value: agentId
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Delete the Lead by Lead Id.
	* @param leadId - Lead Id i.e 931c38fd-6cab-4ad0-9fb8-83952eddeb0e
	* @param agentId - Agent Id i.e AG1634
	*/
	export function apiDasV1LeadLeadIdDelete(leadId: string, agentId?: string, customHeaders: Object = {}): Observable<RemoteData<boolean>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId));
		const allQueryParams: TQueryParam[] = [
				{
					key: 'agentId',
					value: agentId
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'delete',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdDelete(leadId: string, agentId?: string, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId));
		const allQueryParams: TQueryParam[] = [
			{
			key: 'agentId',
			value: agentId
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service and Get the Lead Profile by Lead Id.
	* @param leadId - Lead Id i.e 931c38fd-6cab-4ad0-9fb8-83952eddeb0e
	* @param agentId - Agent Id i.e AG1634
	*/
	export function apiDasV1LeadLeadIdGet(leadId: string, agentId?: string, customHeaders: Object = {}): Observable<RemoteData<LeadProfileResponse>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId));
		const allQueryParams: TQueryParam[] = [
				{
					key: 'agentId',
					value: agentId
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdGet(leadId: string, agentId?: string, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId));
		const allQueryParams: TQueryParam[] = [
			{
			key: 'agentId',
			value: agentId
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service to get lead questions for the lead
	* @param leadId - Lead Id. i.e 931c38fd-6cab-4ad0-9fb8-83952eddeb0e
	* @param questionnaireId - Questionnaire Id. i.e 6               1) 2- Long questionnaire Set               2) 5- Short questionnaire Set               3) 6 - Five Questionnaire Set
	* @param agentId - Agent Id i.e AG1634
	*/
	export function apiDasV1LeadLeadIdLeadprofilesQuestionsQuestionnaireIdGet(leadId: string, questionnaireId: number, agentId?: string, customHeaders: Object = {}): Observable<RemoteData<Array<RiskQuestion>>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadprofiles/questions/${encodeURIComponent(String(questionnaireId))}`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'questionnaireId' + '}', String(questionnaireId));
		const allQueryParams: TQueryParam[] = [
				{
					key: 'agentId',
					value: agentId
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdLeadprofilesQuestionsQuestionnaireIdGet(leadId: string, questionnaireId: number, agentId?: string, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadprofiles/questions/${encodeURIComponent(String(questionnaireId))}'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'questionnaireId' + '}', String(questionnaireId));
		const allQueryParams: TQueryParam[] = [
			{
			key: 'agentId',
			value: agentId
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service for add or update lead questions answers for the Lead
	* @param leadId - Lead Id. i.e 931c38fd-6cab-4ad0-9fb8-83952eddeb0e
	* @param questionnaireId - Questionnaire Id. i.e 6
	* @param body - Lead Answers
	* @param agentId - Agent Id. i.e AG1634
	*/
	export function apiDasV1LeadLeadIdLeadprofilesQuestionsQuestionnaireIdPut(leadId: string, questionnaireId: number, body?: Array<LeadQuestionAnswers>, agentId?: string, customHeaders: Object = {}): Observable<RemoteData<Array<RiskQuestion>>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadprofiles/questions/${encodeURIComponent(String(questionnaireId))}`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'questionnaireId' + '}', String(questionnaireId));
		const allQueryParams: TQueryParam[] = [
				{
					key: 'agentId',
					value: agentId
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'put',
			body: body,
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdLeadprofilesQuestionsQuestionnaireIdPut(leadId: string, questionnaireId: number, body?: Array<LeadQuestionAnswers>, agentId?: string, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadprofiles/questions/${encodeURIComponent(String(questionnaireId))}'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'questionnaireId' + '}', String(questionnaireId));
		const allQueryParams: TQueryParam[] = [
			{
			key: 'agentId',
			value: agentId
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Call investor service for updates the lead Application State
	* @param leadId - Lead Id. i.e 931c38fd-6cab-4ad0-9fb8-83952eddeb0e
	* @param leadStrategyId - Lead Strategy Id. i.e 69599b0d-c385-4abe-a555-5e9fa20e517c
	* @param body - Request. i.e Last Page visited &quot;Set Goal&quot;
	*/
	export function apiDasV1LeadLeadIdLeadstrategiesLeadStrategyIdApplicationstatePost(leadId: string, leadStrategyId: string, body?: LastPageVisitedRequest, customHeaders: Object = {}): Observable<RemoteData<LeadStrategyInfoResponse>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadstrategies/${encodeURIComponent(String(leadStrategyId))}/applicationstate`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'leadStrategyId' + '}', String(leadStrategyId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'post',
			body: body,
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdLeadstrategiesLeadStrategyIdApplicationstatePost(leadId: string, leadStrategyId: string, body?: LastPageVisitedRequest, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadstrategies/${encodeURIComponent(String(leadStrategyId))}/applicationstate'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'leadStrategyId' + '}', String(leadStrategyId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service Gets the lead strategy by lead id
	* @param leadId - Lead Id. i.e 931c38fd-6cab-4ad0-9fb8-83952eddeb0e
	* @param leadStrategyId - Lead Strategy Id. i.e 69599b0d-c385-4abe-a555-5e9fa20e517c
	* @param agentId - Agent Id. i.e AG1634
	*/
	export function apiDasV1LeadLeadIdLeadstrategiesLeadStrategyIdGet(leadId: string, leadStrategyId: string, agentId?: string, customHeaders: Object = {}): Observable<RemoteData<LeadStrategyInfoResponse>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadstrategies/${encodeURIComponent(String(leadStrategyId))}`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'leadStrategyId' + '}', String(leadStrategyId));
		const allQueryParams: TQueryParam[] = [
				{
					key: 'agentId',
					value: agentId
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdLeadstrategiesLeadStrategyIdGet(leadId: string, leadStrategyId: string, agentId?: string, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadstrategies/${encodeURIComponent(String(leadStrategyId))}'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'leadStrategyId' + '}', String(leadStrategyId));
		const allQueryParams: TQueryParam[] = [
			{
			key: 'agentId',
			value: agentId
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service to Update lead goal
	* @param leadId - Lead Id. i.e 931c38fd-6cab-4ad0-9fb8-83952eddeb0e
	* @param leadStrategyId - Lead Strategy Id. i.e 69599b0d-c385-4abe-a555-5e9fa20e517c
	* @param goalId - Goal Id i.e 5b1d9c8a-eff2-41f1-ad2c-dc62e9460083
	* @param body - Lead Goal
	*/
	export function apiDasV1LeadLeadIdLeadstrategiesLeadStrategyIdGoalGoalIdPut(leadId: string, leadStrategyId: string, goalId: string, body?: LeadGoal, customHeaders: Object = {}): Observable<RemoteData<LeadGoalResponse>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadstrategies/${encodeURIComponent(String(leadStrategyId))}/goal/${encodeURIComponent(String(goalId))}`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'leadStrategyId' + '}', String(leadStrategyId)).replace('{' + 'goalId' + '}', String(goalId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'put',
			body: body,
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdLeadstrategiesLeadStrategyIdGoalGoalIdPut(leadId: string, leadStrategyId: string, goalId: string, body?: LeadGoal, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadstrategies/${encodeURIComponent(String(leadStrategyId))}/goal/${encodeURIComponent(String(goalId))}'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'leadStrategyId' + '}', String(leadStrategyId)).replace('{' + 'goalId' + '}', String(goalId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service and create the LeadGoal and update the LeadGoalId in Lead Strategy.
	* @param leadId - Lead Id. i.e 931c38fd-6cab-4ad0-9fb8-83952eddeb0e
	* @param leadStrategyId - Lead Strategy Id. i.e 69599b0d-c385-4abe-a555-5e9fa20e517c
	* @param body - Request. i.e Create Lead Goal attribute values
	*/
	export function apiDasV1LeadLeadIdLeadstrategiesLeadStrategyIdGoalPost(leadId: string, leadStrategyId: string, body?: AddUpdateLeadGoal, customHeaders: Object = {}): Observable<RemoteData<LeadGoalResponse>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadstrategies/${encodeURIComponent(String(leadStrategyId))}/goal`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'leadStrategyId' + '}', String(leadStrategyId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'post',
			body: body,
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdLeadstrategiesLeadStrategyIdGoalPost(leadId: string, leadStrategyId: string, body?: AddUpdateLeadGoal, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadstrategies/${encodeURIComponent(String(leadStrategyId))}/goal'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'leadStrategyId' + '}', String(leadStrategyId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service for update lead strategy.
	* @param leadId - Lead Id. i.e 931c38fd-6cab-4ad0-9fb8-83952eddeb0e
	* @param leadStrategyId - Lead Strategy Id. i.e 69599b0d-c385-4abe-a555-5e9fa20e517c
	* @param body - 
	*/
	export function apiDasV1LeadLeadIdLeadstrategiesLeadStrategyIdPut(leadId: string, leadStrategyId: string, body?: LeadStrategyUpdateRequest, customHeaders: Object = {}): Observable<RemoteData<LeadStrategyInfoResponse>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadstrategies/${encodeURIComponent(String(leadStrategyId))}`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'leadStrategyId' + '}', String(leadStrategyId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'put',
			body: body,
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdLeadstrategiesLeadStrategyIdPut(leadId: string, leadStrategyId: string, body?: LeadStrategyUpdateRequest, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}/leadstrategies/${encodeURIComponent(String(leadStrategyId))}'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId)).replace('{' + 'leadStrategyId' + '}', String(leadStrategyId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Convert lead prospect
	* @param leadId - Lead Id i.e 931c38fd-6cab-4ad0-9fb8-83952eddeb0e
	* @param agentId - Agent Id. i.e AG1634
	*/
	export function apiDasV1LeadLeadIdProspectPost(leadId: string, agentId?: string, customHeaders: Object = {}): Observable<RemoteData<boolean>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}/Prospect`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId));
		const allQueryParams: TQueryParam[] = [
				{
					key: 'agentId',
					value: agentId
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'post',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdProspectPost(leadId: string, agentId?: string, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}/Prospect'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId));
		const allQueryParams: TQueryParam[] = [
			{
			key: 'agentId',
			value: agentId
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Update Lead
	* @param leadId - Lead Id i.e 75299dbc-4df6-4bbb-a57a-dc0d74a89b6e
	* @param body - The request.
	*/
	export function apiDasV1LeadLeadIdPut(leadId: string, body?: AddUpdateLead, customHeaders: Object = {}): Observable<RemoteData<LeadProfileResponse>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadId))}`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'put',
			body: body,
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadIdPut(leadId: string, body?: AddUpdateLead, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadId))}'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service to get risk profile by lead strategy id
	* @param leadStrategyId - Lead Strategy Id. i.e 69599b0d-c385-4abe-a555-5e9fa20e517c
	* @param agentId - Agent Id i.e AG1634
	*/
	export function apiDasV1LeadLeadStrategyIdRiskGet(leadStrategyId: string, agentId?: string, customHeaders: Object = {}): Observable<RemoteData<LeadRiskResponse>> {
		const path = `/api/das/v1/lead/${encodeURIComponent(String(leadStrategyId))}/Risk`.replace(/^\//, '').replace('{' + 'leadStrategyId' + '}', String(leadStrategyId));
		const allQueryParams: TQueryParam[] = [
				{
					key: 'agentId',
					value: agentId
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadStrategyIdRiskGet(leadStrategyId: string, agentId?: string, ): string {
		const path = '/api/das/v1/lead/${encodeURIComponent(String(leadStrategyId))}/Risk'.replace(/^\//, '').replace('{' + 'leadStrategyId' + '}', String(leadStrategyId));
		const allQueryParams: TQueryParam[] = [
			{
			key: 'agentId',
			value: agentId
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service to get account details
	* @param leadStrategyID - Lead Strategy Id. i.e 69599b0d-c385-4abe-a555-5e9fa20e517c
	* @param agentId - Agent Id. i.e AG1634
	*/
	export function apiDasV1LeadLeadStrategyLeadStrategyIDAccountDetailsGet(leadStrategyID: string, agentId?: string, customHeaders: Object = {}): Observable<RemoteData<StrategyAccountDetailsResponse>> {
		const path = `/api/das/v1/lead/leadStrategy/${encodeURIComponent(String(leadStrategyID))}/accountDetails`.replace(/^\//, '').replace('{' + 'leadStrategyID' + '}', String(leadStrategyID));
		const allQueryParams: TQueryParam[] = [
				{
					key: 'agentId',
					value: agentId
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadLeadStrategyLeadStrategyIDAccountDetailsGet(leadStrategyID: string, agentId?: string, ): string {
		const path = '/api/das/v1/lead/leadStrategy/${encodeURIComponent(String(leadStrategyID))}/accountDetails'.replace(/^\//, '').replace('{' + 'leadStrategyID' + '}', String(leadStrategyID));
		const allQueryParams: TQueryParam[] = [
			{
			key: 'agentId',
			value: agentId
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Get other income source type
	*/
	export function apiDasV1LeadOtherincomesourcetypesGet(customHeaders: Object = {}): Observable<RemoteData<Array<OtherRetirementIncomeSourceType>>> {
		const path = `/api/das/v1/lead/otherincomesourcetypes`.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadOtherincomesourcetypesGet(): string {
		const path = '/api/das/v1/lead/otherincomesourcetypes'.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
	* @param body - 
	*/
	export function apiDasV1LeadPost(body?: AddUpdateLead, customHeaders: Object = {}): Observable<RemoteData<LeadProfileResponse>> {
		const path = `/api/das/v1/lead`.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'post',
			body: body,
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadPost(body?: AddUpdateLead, ): string {
		const path = '/api/das/v1/lead'.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Calling investor service and Get the Lead Status with LastPage Visited Count.
	*/
	export function apiDasV1LeadStatusGet(customHeaders: Object = {}): Observable<RemoteData<{ [key: string]: number; }>> {
		const path = `/api/das/v1/lead/status`.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1LeadStatusGet(): string {
		const path = '/api/das/v1/lead/status'.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
}
